// 后端因为语言导致返回的题型type值不一致，规整以下并返回正确type值
export const getQuesType = (val) => {
    let type = '2' // 默认手机号
    switch (val) {
        case '2': 
        case '202': 
        case '302': 
            // 手机号
            type = '2'
            break;
        case '3':
        case '203':
            // 单行输入框
            type = '3'
            break;
        case '4':
        case '204':
        case '304':
            // 多行输入框
            type = '4'
            break;
        case '5':
        case '305':
            // 填空题
            type = '5'
            break;
        case '35':
        case '235':
        case '335':
            // 多项填空
            type = '35'
            break;
        case '8':
        case '208':
        case '308':
            // 单选题
            type = '8'
            break;
        case '10':
        case '210':
        case '310':
            // 多选题
            type = '10'
            break;
        case '12':
        case '212':
        case '312':
            // 判断题
            type = '12'
            break;
        case '9':
        case '209':
        case '309':
            // 下拉框
            type = '9'
            break;
        case '6':
        case '206':
        case '306':
            // 图片选择
            type = '6'
            break;
        case '11':
        case '211':
        case '311':
            // 星级评分
            type = '11'
            break;
        case '13':
        case '213':
        case '313':
            // 日期选择
            type = '13'
            break;
        case '15':
        case '215':
        case '315':
            // 地理位置
            type = '15'
            break;
        case '16':
        case '216':
        case '316':
            // 城市选择
            type = '16'
            break;
        case '17':
        case '217':
        case '317':
            // 时间选择
            type = '17'
            break;
        case '36':
        case '236':
        case '336':
            // 级联题
            type = '36'
            break;
        case '37':
        case '237':
        case '337':
            // 比重题
            type = '37'
            break;
        case '38':
        case '238':
        case '338':
            // 量表题
            type = '38'
            break;
        case '19':
        case '219':
        case '319':
            // 矩阵单选
            type = '19'
            break;
        case '20':
        case '220':
        case '320':
            // 矩阵多选
            type = '20'
            break;
        case '21':
        case '221':
        case '321':
            // 矩阵星级评分
            type = '21'
            break;
        case '22':
        case '222':
        case '322':
            // 矩阵填空
            type = '22'
            break;
        case '39':
        case '239':
        case '339':
            // 矩阵组合
            type = '39'
            break;
        case '25':
        case '225':
        case '325':
            // 段落标题
            type = '25'
            break;
        case '26':
        case '226':
        case '326':
            // 分页
            type = '26'
            break;
        case '33':
        case '233':
        case '333':
            // 上传文件
            type = '33'
            break;
        case '34':
        case '234':
        case '334':
            // 横向填空
            type = '34'
            break;
        case '14':
        case '214':
        case '314':
            // 排序题
            type = '14'
            break;
    }
    // console.log('type :>> ', type);
    return type
}